import { render } from "./Ratings.vue?vue&type=template&id=e3facf36&scoped=true"
import script from "./Ratings.vue?vue&type=script&lang=js"
export * from "./Ratings.vue?vue&type=script&lang=js"

import "./Ratings.vue?vue&type=style&index=0&id=e3facf36&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3facf36"]])

export default __exports__